{
	"panelCurves": "Curves",
	"sliderDarks": "Darks",
	"sliderHighlights": "Highlights",
	"sliderLights": "Lights",
	"sliderShadows": "Shadows",
	"stopDarks": "Darks",
	"stopLights": "Lights",
	"stopMids": "Mids"
}
